import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'
import {HashTag, DeepLink} from '../services/hashtag'
import {URLHash} from '../services/router/router'
import axios from 'axios'

const LUNA_ASSIST_URL = '/api/v1/marketing/luna-assists/'

export class LunaAssist extends React.Component {
    constructor(props) {
        super(props)

        let curHash = this.generateHash()

        this.state = {
            submitted: false,
            loading: false,
            hashTitle: curHash.title,
            hasUser: this.props.currentUser,
            user_id: this.props.currentUser ? this.props.currentUser.traveler_user_id : -1,
            user_guid: this.props.currentUser ? this.props.currentUser.traveler_guid : -1,
            email: this.props.currentUser ? this.props.currentUser.traveler_email : '',
            currentLocation: ' Location: ' + window.location.href,
            subject: this.toTitleCase(curHash.title),
            description: '',
            errorMessage: null
        }

        _.bindAll(this,
            'refreshFields',
            'handleChange',
            'getForm',
            'submitLunaForm',
            'resetLuna',
            'generateHash',
            'toTitleCase'
        )
    }

    componentDidMount() {
        this.refreshFields()
    }
  
    toTitleCase(str) {
        return str.replace(/\w\S*/g, function(txt) {return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()})
    }


    componentWillUpdate(nextProps, nextState) {
        let nextHash = this.generateHash()
        if (this.state.hashTitle !== nextHash.title) {
            this.setState({subject: this.toTitleCase(nextHash.title), hashTitle: nextHash.title})
        }
    }

    componentDidUpdate(prevProps, prevState) {
        this.refreshFields()
    }

    generateHash() {
    // generate the hashtag    
        let curHash = window.location.hash
        let hashToSegments = URLHash.parse(curHash)
        let curDeepLink = DeepLink.parse(hashToSegments)

        // try to make sense of the segments to create a name
        let hashName = {
            destination: '',
            obj: '',
            section: '',
            subsection: ''
        }
        let _this = this
        _.each(hashToSegments, function(seg) {
            if (seg.type == 'leg') {
                // look for a destination in the leg
                let curLeg = _this.props.legs.filter((leg) => {                
                    return leg.get('id') === seg.identifier
                })              

                let curDest = curLeg.getIn([0, 'destination', 'title']) ? curLeg.getIn([0, 'destination', 'title']) : ''
                if (typeof curDest != 'undefined') {
                    hashName.destination = curDest
                }
            } else if (seg.type == 'uistatus') {
                // check to see if details
                let sections = seg.identifier.split('~')
                hashName.section = sections[0]
                hashName.subsection = sections[1]
                // otherwise mark section
            } else if (seg.type == 'accommodation') {
                let accom = null
                let leg = _this.props.legs.find((leg) => {
                    let accoms = leg.getIn(['accommodations'])
                    accom = accoms.find((accom) => {
                        return accom.get('accommodation_guid') === seg.identifier
                    })
                    if (accom) {
                        return leg
                    }
                })
                if (leg) {                
                    hashName.obj = accom.get('name')
                }              
            } else if (seg.type == 'activity') {
                let act = null
                let leg = _this.props.legs.find((leg) => {
                    let acts = leg.getIn(['activities'])
                    act = acts.find((act) => {
                        return act.get('place_id') === seg.identifier
                    })
                    if (act) {
                        return leg
                    }
                })
                if (leg) {                
                    hashName.obj = act.get('name')
                }
            }
        })
        let hashTitle = ''
        if (hashName.subsection == 'details' && hashName.obj != '') {
            hashTitle = hashName.obj + ' (' + hashName.destination + ')'
        } else {
            hashTitle = hashName.destination + ' ' + hashName.section
        }

        if (hashTitle.trim() == '') {
            hashTitle = this.props.tripName
        }

        return HashTag.new(hashTitle, curDeepLink).serialize()
    }

    handleChange(target, value) {
        this.setState({[target]: value})
    }

    resetLuna() {
        let curHash = this.generateHash()

        this.setState({
            submitted: false,
            loading: false,
            subject: curHash.title,
            description: '',
            errorMessage: null
        })
        this.props.updateActiveMenuItem(null)
    }

    refreshFields() {
    // evertime we auto set a field, we have to trigger the class change to move the label up/down
        $('.input-plain input').each(function() {
            var target = $(this)
            target.parent().removeClass('is-focused')
            target.val() ? target.parent().addClass('has-value') : target.parent().removeClass('has-value')
        })
    }

    submitLunaForm() {
        this.setState({loading: true})
        let self = this    
        axios.post(LUNA_ASSIST_URL, {
            user_id: this.state.user_id,
            traveler_guid: this.state.traveler_guid,
            email: this.state.email,
            subject: this.refs.subject.value ? this.refs.subject.value : '',
            description: this.refs.description.value ? this.refs.description.value + this.state.currentLocation : this.state.currentLocation,
        }).then(function(response) {
            if (response.data !== undefined) {   
                // TODO: Fade out sidebar content and show success message     
                console.log(response)
                self.setState({submitted: true, loading: false})
            } else {
                console.log('ERROR: in submitLunaForm error')
                console.log(response)
                self.setState({errorMessage: response.data, loading: false})
            }
        }).catch(function(err) {
            console.log('ERROR: in submitLunaForm error')
            console.log(err)
            self.setState({errorMessage: 'Error submitting request', loading: false})
        })
    }

    getForm() {
        if (!this.state.submitted) {
            return (
                <div className="contact-content">
                    <div className="form-group input-plain">
                        <label htmlFor="subject">Subject</label>
                        <input
                type="text"
                name="subject"
                className="form-control input-medium"
                ref="subject"
                value={this.state.subject} 
                onChange={() => {this.handleChange('subject', this.refs.subject.value)}}/>
                    </div>
                    <div className="form-group input-plain">
                        <textarea
                name="description"
                className="form-control input-medium"
                ref="description"
                placeholder="What can we help you with?"
                value={this.state.description} 
                onChange={() => {this.handleChange('description', this.refs.description.value)}}/>
                    </div>
                    <div className="form-group">
                        <button
                type="submit"
                onClick={() => { this.submitLunaForm() }}
                className="btn btn-medium">
                  Ask Luna
                        </button>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="luna-assist-content">
                    <h1>Thanks!</h1>
                    <div>
            We will follow up with you as soon as possible. 
                    </div>
                </div>
            )
        }
    }

    render() {
        let classes = classNames(
            'widget-popup',
            {'active': this.props.activeMenuItem === 'lunaassist'}
        )

        return (
            <div id="luna-assist" className={classes}>
                <div className="widget-header-block">
                    <i className="icon-close" onClick={() => {this.resetLuna()}}/>
                </div>
                <div id="luna-assist-content">
                    {this.getForm()}
                </div>
            </div>
        )
    }
}